export { default } from './SeguroAuto25MaoNaRoda';
